export const CONFIG = 'config';
export const TRIMS = 'trims';
export const EXTERIOR = 'exterior';
export const WHEELS = 'wheels';
export const INTERIOR = 'interior';
export const PACKAGES = 'packages';
export const OPTIONS = 'options';
export const SUMMARY = 'summary';
export const MODELS = 'models';
export const PACKAGES_AND_OPTIONS = 'packages.and.options';
